import axios from "axios";
import Config from "../../config/index";
import {
  GET_PRODUCTS_LIST_FOR_DPP_REQUEST,
  GET_PRODUCTS_LIST_FOR_DPP_SUCCESS,
  GET_PRODUCTS_LIST_FOR_DPP_FAILURE,
  GET_ALL_DATA_FOR_DPP_REQUEST,
  GET_ALL_DATA_FOR_DPP_SUCCESS,
  GET_ALL_DATA_FOR_DPP_FAILURE,
  GET_TECHNICAL_DOCUMENTS_REQUEST,
  GET_TECHNICAL_DOCUMENTS_SUCCESS,
  GET_TECHNICAL_DOCUMENTS_FAILURE,
  GET_DURABILITY_REQUEST,
  GET_DURABILITY_SUCCESS,
  GET_DURABILITY_FAILURE,
  GET_COC_REQUEST,
  GET_COC_SUCCESS,
  GET_COC_FAILURE,
  GET_RAW_MATERIAL_REQUEST,
  GET_RAW_MATERIAL_SUCCESS,
  GET_RAW_MATERIAL_FAILURE,
  GET_PWM_REQUEST,
  GET_PWM_SUCCESS,
  GET_PWM_FAILURE,
  GET_EVT_REQUEST,
  GET_EVT_SUCCESS,
  GET_EVT_FAILURE,
  GET_REPAIR_MAINTAENANCE_REQUEST,
  GET_REPAIR_MAINTAENANCE_SUCCESS,
  GET_REPAIR_MAINTAENANCE_FAILURE,
  GET_MANUFACTURING_REQUEST,
  GET_MANUFACTURING_SUCCESS,
  GET_MANUFACTURING_FAILURE,
  GET_ITEMS_DETAILS_BY_DPP_ID_REQUEST,
  GET_ITEMS_DETAILS_BY_DPP_ID_SUCCESS,
  GET_ITEMS_DETAILS_BY_DPP_ID_FAILURE,
  GET_DPP_PARENT_REQUEST,
  GET_DPP_PARENT_SUCCESS,
  GET_DPP_PARENT_FAILURE,
  GET_CHILD_PARENT_REQUEST,
  GET_CHILD_PARENT_SUCCESS,
  GET_CHILD_PARENT_FAILURE,
   GET_TREE_MAP_REQUEST,
  GET_TREE_MAP_SUCCESS,
  GET_TREE_MAP_FAILURE,

  UPLOADCSV_PASSPORT_REQUEST,
  UPLOADCSV_PASSPORT_SUCCESS,
  UPLOADCSV_PASSPORT_FAILURE,
} from "./dppTypes";

let baseUrl = Config.baseUrl;
let baseUrlFileUploadTemp = Config.baseUrlFileUploadTemp;

const getProductsListForDppRequest = () => {
  return {
    type: GET_PRODUCTS_LIST_FOR_DPP_REQUEST,
  };
};

const getProductsListForDppSuccess = (payload) => {
  return {
    type: GET_PRODUCTS_LIST_FOR_DPP_SUCCESS,
    payload: payload,
  };
};

const getProductsListForDppFailure = (error) => {
  return {
    type: GET_PRODUCTS_LIST_FOR_DPP_FAILURE,
    payload: error,
  };
};

const getProductsListForDpp = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getProductsListForDppRequest());
    let url = `${baseUrl}/dpp/product_passport/get_all`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getProductsListForDppSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getProductsListForDppFailure(err.message));
      });
  };
};

const getAllDataForDppRequest = () => {
  return {
    type: GET_ALL_DATA_FOR_DPP_REQUEST,
  };
};

const getAllDataForDppSuccess = (payload) => {
  return {
    type: GET_ALL_DATA_FOR_DPP_SUCCESS,
    payload: payload,
  };
};

const getAllDataForDppFailure = (error) => {
  return {
    type: GET_ALL_DATA_FOR_DPP_FAILURE,
    payload: error,
  };
};

const getAllDataForDpp = (dppCode, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getAllDataForDppRequest());
    let url = `${baseUrl}/dpp/main/get_all?dppCode=${dppCode}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAllDataForDppSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getAllDataForDppFailure(err.message));
      });
  };
};

const getParentDppCodeRequest = () => {
  return {
    type: GET_DPP_PARENT_REQUEST,
  };
};

const getParentDppCodeSuccess = (payload) => {
  return {
    type: GET_DPP_PARENT_SUCCESS,
    payload: payload,
  };
};

const getParentDppCodeFailure = (error) => {
  return {
    type: GET_DPP_PARENT_FAILURE,
    payload: error,
  };
};

const getParentDppCode = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getParentDppCodeRequest());
    let url = `${baseUrl}/dpp/v1/product_passport/get_parent_dppcode`;

    axios
      .get(url, headers)
      .then((response) => {
        console.log("response", response)
        dispatch(getParentDppCodeSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getParentDppCodeFailure(err.message));
      });
  };
};
const getParentRawCodesRequest = () => {
  return {
    type: GET_CHILD_PARENT_REQUEST,
  };
};

const getParentRawCodesSuccess = (payload) => {
  return {
    type: GET_CHILD_PARENT_SUCCESS,
    payload: payload,
  };
};

const getParentRawCodesFailure = (error) => {
  return {
    type: GET_CHILD_PARENT_FAILURE,
    payload: error,
  };
};

const getParentRawCodes = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getParentRawCodesRequest());
    let url = `${baseUrl}/dpp/product_passport/get_rmId?dppId=${dppId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getParentRawCodesSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getParentRawCodesFailure(err.message));
      });
  };
};

const getTechnicalDocumentsRequest = () => {
  return {
    type: GET_TECHNICAL_DOCUMENTS_REQUEST,
  };
};

const getTechnicalDocumentsSuccess = (payload) => {
  return {
    type: GET_TECHNICAL_DOCUMENTS_SUCCESS,
    payload: payload,
  };
};

const getTechnicalDocumentsFailure = (error) => {
  return {
    type: GET_TECHNICAL_DOCUMENTS_FAILURE,
    payload: error,
  };
};

const getTechnicalDocuments = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getTechnicalDocumentsRequest());
    let url = `${baseUrl}/dpp/main_api/technical_documents_bydpp?dppId=${dppId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getTechnicalDocumentsSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getTechnicalDocumentsFailure(err.message));
      });
  };
};

const getDurabilityRequest = () => {
  return {
    type: GET_DURABILITY_REQUEST,
  };
};

const getDurabilitySuccess = (payload) => {
  return {
    type: GET_DURABILITY_SUCCESS,
    payload: payload,
  };
};

const getDurabilityFailure = (error) => {
  return {
    type: GET_DURABILITY_FAILURE,
    payload: error,
  };
};

const getDurability = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getDurabilityRequest());
    let url = `${baseUrl}/dpp/main_api/durability_bydpp?dppId=${dppId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getDurabilitySuccess(response.data));
      })
      .catch((err) => {
        dispatch(getDurabilityFailure(err.message));
      });
  };
};

const getChainOfCustodyRequest = () => {
  return {
    type: GET_COC_REQUEST,
  };
};

const getChainOfCustodySuccess = (payload) => {
  return {
    type: GET_COC_SUCCESS,
    payload: payload,
  };
};

const getChainOfCustodyFailure = (error) => {
  return {
    type: GET_COC_FAILURE,
    payload: error,
  };
};

const getChainOfCustody = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getChainOfCustodyRequest());
    let url = `${baseUrl}/dpp/main_api/coc?dppId=${dppId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getChainOfCustodySuccess(response.data));
      })
      .catch((err) => {
        dispatch(getChainOfCustodyFailure(err.message));
      });
  };
};

const getPackagingWasteManagementRequest = () => {
  return {
    type: GET_PWM_REQUEST,
  };
};

const getPackagingWasteManagementSuccess = (payload) => {
  return {
    type: GET_PWM_SUCCESS,
    payload: payload,
  };
};

const getPackagingWasteManagementFailure = (error) => {
  return {
    type: GET_PWM_FAILURE,
    payload: error,
  };
};

const getPackagingWasteManagement = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getPackagingWasteManagementRequest());
    let url = `${baseUrl}/dpp/main_api/packaging_waste_management?dppId=${dppId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getPackagingWasteManagementSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getPackagingWasteManagementFailure(err.message));
      });
  };
};

const getEnvironmentalRequest = () => {
  return {
    type: GET_EVT_REQUEST,
  };
};

const getEnvironmentalSuccess = (payload) => {
  return {
    type: GET_EVT_SUCCESS,
    payload: payload,
  };
};

const getEnvironmentalFailure = (error) => {
  return {
    type: GET_EVT_FAILURE,
    payload: error,
  };
};

const getEnvironmental = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getEnvironmentalRequest());
    let url = `${baseUrl}/dpp/main_api/environmental?dppId=${dppId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getEnvironmentalSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getEnvironmentalFailure(err.message));
      });
  };
};

const getRepairMaintenanceRequest = () => {
  return {
    type: GET_REPAIR_MAINTAENANCE_REQUEST,
  };
};

const getRepairMaintenanceSuccess = (payload) => {
  return {
    type: GET_REPAIR_MAINTAENANCE_SUCCESS,
    payload: payload,
  };
};

const getRepairMaintenanceFailure = (error) => {
  return {
    type: GET_REPAIR_MAINTAENANCE_FAILURE,
    payload: error,
  };
};

const getRepairMaintenance = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getRepairMaintenanceRequest());
    let url = `${baseUrl}/dpp/main_api/repair_recycle_value?dppId=${dppId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getRepairMaintenanceSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getRepairMaintenanceFailure(err.message));
      });
  };
};

const getRawMaterialRequest = () => {
  return {
    type: GET_RAW_MATERIAL_REQUEST,
  };
};

const getRawMaterialSuccess = (payload) => {
  return {
    type: GET_RAW_MATERIAL_SUCCESS,
    payload: payload,
  };
};

const getRawMaterialFailure = (error) => {
  return {
    type: GET_RAW_MATERIAL_FAILURE,
    payload: error,
  };
};

const getRawMaterial = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getRawMaterialRequest());
    let url = `${baseUrl}/dpp/main_api/raw_material?dppId=${dppId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getRawMaterialSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getRawMaterialFailure(err.message));
      });
  };
};

const getManufacturingRequest = () => {
  return {
    type: GET_MANUFACTURING_REQUEST,
  };
};

const getManufacturingSuccess = (payload) => {
  return {
    type: GET_MANUFACTURING_SUCCESS,
    payload: payload,
  };
};

const getManufacturingFailure = (error) => {
  return {
    type: GET_MANUFACTURING_FAILURE,
    payload: error,
  };
};

const getManufacturing = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getManufacturingRequest());
    let url = `${baseUrl}/dpp/main_api/manufacturing?dppId=${dppId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getManufacturingSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getManufacturingFailure(err.message));
      });
  };
};

const getItemsDetailsByDppIdRequest = () => {
  return {
    type: GET_ITEMS_DETAILS_BY_DPP_ID_REQUEST,
  };
};

const getItemsDetailsByDppIdSuccess = (payload) => {
  return {
    type: GET_ITEMS_DETAILS_BY_DPP_ID_SUCCESS,
    payload: payload,
  };
};

const getItemsDetailsByDppIdFailure = (error) => {
  return {
    type: GET_ITEMS_DETAILS_BY_DPP_ID_FAILURE,
    payload: error,
  };
};

const getItemsDetailsByDppId = (dppId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getItemsDetailsByDppIdRequest());
    let url = `${baseUrl}/dpp/rm_traceability/dpp_id_for_item_details?dppId=${dppId}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getItemsDetailsByDppIdSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getItemsDetailsByDppIdFailure(err.message));
      });
  };
};


const uploadCsvForPassportRequest = () => {
  return {
    type: UPLOADCSV_PASSPORT_REQUEST,
  };
};

const uploadCsvForPassportSuccess = (payload) => {
  return {
    type: UPLOADCSV_PASSPORT_SUCCESS,
    payload: payload,
  };
};

const uploadCsvForPassportFailure = (error) => {
  return {
    type: UPLOADCSV_PASSPORT_FAILURE,
    payload: error,
  };
};

const uploadCsvForPassport = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(uploadCsvForPassportRequest());
    let url = `${baseUrlFileUploadTemp}/dpp_main/upload`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(uploadCsvForPassportSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(uploadCsvForPassportFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

export const getTreeMapRequest = () => ({
  type: GET_TREE_MAP_REQUEST,
});

export const getTreeMapSuccess = (data) => ({
  type: GET_TREE_MAP_SUCCESS,
  payload: data,
});

export const getTreeMapFailure = (error) => ({
  type: GET_TREE_MAP_FAILURE,
  payload: error,
});
 
 const getTreeMap = (dppCode, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  
  return (dispatch) => {
    dispatch(getTreeMapRequest());
    let url = `${baseUrl}/dpp/main/getTreeMap?dppCode=${dppCode}`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getTreeMapSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getTreeMapFailure(err.message));
      });
  };
};

export {
  getProductsListForDpp,
  getAllDataForDpp,
  getTechnicalDocuments,
  getDurability,
  getChainOfCustody,
  getPackagingWasteManagement,
  getEnvironmental,
  getRepairMaintenance,
  getRawMaterial,
  getManufacturing,
  getItemsDetailsByDppId,
  getParentRawCodes,
  getParentDppCode,
  uploadCsvForPassport,
  getTreeMap,
};
